
import {jsx} from '@emotion/react';

import { Component } from 'react';
import _ from 'lodash';

import {withRouter} from 'react-router-dom';
import {Link} from 'react-router-dom';

import {connectLocation} from '../location/LocationConnectors';


import {If, DataOrEmpty, Section, StepColumns} from './utilities';

import css from './styles_step'

import { Model3D, reloadModel} from './model3d';

import {Disclaimers} from './header_footer';

import {loadRoof, saveRoof} from './api';
import {logProjectId, logChangeStep, logViewStep} from './analytics';
import {ConfigurationConnector, VariableCTAButton as CTAButton} from "./BYRConnectors";
import { DataTrack, PrefixWithLocale } from "../Utilities";

import SummaryPDF from './pdf/summary';
import {ContractorNameReduxConnector} from "./CustomizeConnectors";

class XSummary extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data || {}
    }
    this.onDownloadPDF = this.onDownloadPDF.bind(this);
  }

  componentDidMount() {
    let roofid = _.get(this.props, 'match.params.roofid', null);
    // Save or load the roof we're in.
    if(roofid) {
      loadRoof(roofid, (roofData) => {
        this.setState({data: roofData});
        logProjectId(roofid, false);
        reloadModel(roofData, true);
        logViewStep();
      });
    } else {
      saveRoof(this.state.data, (id) => {
        this.setState({roofId: id});
        this.props.setRoofId(id);
        logProjectId(id);
      });
      logChangeStep('summary', this.props.configuration.slug);
    }
  }

  onDownloadPDF(e) {
    e.preventDefault();
    let pdf = new SummaryPDF();
    pdf.generate('summary.pdf');
  }

  render() {
    const { t, zip, locale } = this.props;

    const mailto = '?' +
        'subject=' + escape(t('build_your_roof.share_subject')) + '&' +
        'body=' + escape(
      "https://www.owenscorning.com/roofing/build-your-roof/" +
      (_.get(this.props.configuration, 'slug') ? _.get(this.props.configuration, 'slug') + '/' : '') +
      "roof-" + this.state.roofId + '?e');

    const referral = this.state.roofId ? '?roofId=' + this.state.roofId : '';
    const readonly = this.props.summary_only;
    const customized = !!this.props.configuration.slug;
    return (
      <Section>
        <StepColumns>
          <div className="col">
            <div css={css.step}>
              <div css={css.stepHeadingIntro}>
                <h1 id="summary-pdf-intro-header" className="h2 stepHeading">{t('build_your_roof.summary_heading')}</h1>
                <If condition={customized}>
                  <p id="summary-pdf-intro-copy" >{t('build_your_roof.summary_description_customized', {contractor: this.props.contractorName})}</p>
                </If>
                <If condition={!customized}>
                  <p id="summary-pdf-intro-copy" >{t('build_your_roof.summary_description')}</p>
                </If>
                <If condition={!(readonly && customized)}>
                  <CTAButton href="#contractor" data-track="find-a-professional" data-track-professional="contractor">{t('build_your_roof.find_a_contractor')}</CTAButton>
                </If>
              </div>

              <h3 id="summary-pdf-summary-header" >{t('build_your_roof.summary')}</h3>

              <ul className="summaryDetails" css={css.summaryList}>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.shingle_line')}</span>
                    <If condition={!readonly}>
                      <Link to="/shingles" data-track="tool-edit" data-track-edit-step={t('build_your_roof.shingle_line')} data-track-selected-option={_.get(this.state.data, 'selected_shingle[1].name', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" >
                    <DataOrEmpty object={this.state.data} path={'selected_shingle[0].name'}/>&nbsp;
                    <DataOrEmpty object={this.state.data} path={'selected_shingle[1].name'}/>
                  </span>
                </li>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.ice_water')}</span>
                    <If condition={!readonly}>
                      <Link to="/ice-water" data-track="tool-edit" data-track-edit-step={t('build_your_roof.ice_water')} data-track-selected-option={_.get(this.state.data, 'selected_ice-water.name', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" ><DataOrEmpty object={this.state.data} path={'selected_ice-water.name'}/></span>
                </li>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.underlayment')}</span>
                    <If condition={!readonly}>
                      <Link to="/underlayment" data-track="tool-edit" data-track-edit-step={t('build_your_roof.underlayment')} data-track-selected-option={_.get(this.state.data, 'selected_underlayment.name', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" ><DataOrEmpty object={this.state.data} path={'selected_underlayment.name'}/></span>
                </li>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.starter_shingles')}</span>

                    <If condition={!readonly}>
                      <Link to="/starter-shingles" data-track="tool-edit" data-track-edit-step={t('build_your_roof.starter_shingles')} data-track-selected-option={_.get(this.state.data, 'selected_starter-shingles.name', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" ><DataOrEmpty object={this.state.data} path={'selected_starter-shingles.name'}/></span>
                </li>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.hip_ridge')}</span>
                    <If condition={!readonly}>
                      <Link to="/hip-ridge" data-track="tool-edit" data-track-edit-step={t('build_your_roof.hip_ridge')} data-track-selected-option={_.get(this.state.data, 'selected_hip-ridge.name', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" ><DataOrEmpty object={this.state.data} path={'selected_hip-ridge.name'}/></span>
                </li>
                <li>
                  <div className="summaryEditContainer">
                    <span className="stepSummaryHeading">{t('build_your_roof.ventilation_exhaust_summary')}</span>
                    <If condition={!readonly}>
                      <Link to="/ventilation" data-track="tool-edit" data-track-edit-step={t('build_your_roof.ventilation_exhaust_summary')} data-track-selected-option={_.get(this.state.data, 'selected_ventilation', '')}>{t('build_your_roof.summary_edit')}</Link>
                    </If>
                  </div>

                  <span className="stepSummaryValue" >
                    {this.state.data.selected_ventilation ? t('build_your_roof.ventilation_' + this.state.data.selected_ventilation) : '--'}
                  </span>
                </li>
              </ul>
              <If condition={!this.state.roofId}>
                <div css={css.actions}>
                  <p><strong>{t('build_your_roof.summary_roofer_already')}</strong> {t('build_your_roof.summary_print_your_roof')}</p>
                  <div>
                    {/* PDF Download is using it's own layout and rendering, also grabs text / 3D render image from elements at creation */}
                    <a href="#" target="_blank" onClick={(e) => this.onDownloadPDF(e)} data-track="file-download" data-track-doc-type="" data-track-file-name="summary" data-track-file-type="pdf"><i className="fa fa-file-pdf-o" aria-hidden="true"></i><span>{t('build_your_roof.download')}</span></a> |
                    <a href="#!" target="_blank" onClick={() => window.print()} data-track="print"><i className="fa fa-print" aria-hidden="true"></i><span>{t('build_your_roof.print')}</span></a>
                  </div>
                </div>
              </If>
              <If condition={this.state.roofId}>
                <div css={css.actions}>
                  <p><strong>{t('build_your_roof.summary_roofer_already')}</strong> {t('build_your_roof.summary_roofer_details')}</p>
                  <div>
                    <DataTrack track="file-download" file-name="Build Your Roof Summary" doc-type="Summary" file-type=".pdf">
                      <a href="#" target="_blank" onClick={(e) => this.onDownloadPDF(e)} data-track="file-download" data-track-doc-type="" data-track-file-name="summary" data-track-file-type="pdf"><i className="fa fa-file-pdf-o" aria-hidden="true"></i><span>{t('build_your_roof.download')}</span></a>
                    </DataTrack>
                    |
                    <DataTrack track="print" doc-type="Summary">
                      <a href="#!" target="_blank" onClick={() => window.print()}><i className="fa fa-print" aria-hidden="true"></i><span>{t('build_your_roof.print')}</span></a>
                    </DataTrack>
                    |
                    <DataTrack track="share" share-platform="Email">
                      <a href={'mailto:' + mailto}><i className="fa fa-share-square-o" aria-hidden="true"></i><span>{t('build_your_roof.share')}</span></a>
                    </DataTrack>
                  </div>
                </div>
              </If>
            </div>
          </div>

          <div className="col">
            <Model3D data={this.state.data} />
          </div>
        </StepColumns>

        <div css={css.explore} >
          <div className="explore-copy">
            <h2 className="body-font">{t('build_your_roof.explore_colors')}</h2>
            <p>{t('build_your_roof.explore_colors_description')}</p>
          </div>
          <div className="explore-links">
            <div className="explore-link-column" >
              <a
                href={PrefixWithLocale("/roofing/shingles", locale.code)}
                target="_blank"
                data-track="learn-more"
                data-track-destination="Browse Shingle Colors"
              >
                <i className="fa fa-th" aria-hidden="true"></i>
                {t('build_your_roof.browse_shingle_colors')}
              </a>
              <a href="http://designeyeq.owenscorning.com/?src=rfg" target="_blank" data-track="learn-more" data-track-destination="Try on Shingles"><i className="fa fa-home" aria-hidden="true"></i> {t('build_your_roof.try_on_shingles')}</a>
            </div>
            <div className="explore-link-column" >
              <a
                href={PrefixWithLocale("/roofing/design-inspire/colors-of-the-season?tab=style-boards", locale.code)}
                target="_blank"
                data-track="learn-more"
                data-track-destination="Explore Style Boards"
              >
                <i className="fa fa-paint-brush" aria-hidden="true"></i>
                {t('build_your_roof.explore_style_boards')}
              </a>
              <DataTrack track="order-sample" destination="Order Sample">
                <a href="https://cmsoc.reachout.cloud/" target="_blank"><i className="fa fa-file" aria-hidden="true"></i> {t('build_your_roof.order_printed')}</a>
              </DataTrack>
            </div>
          </div>
        </div>

        <Disclaimers location={location} />

        <div id="contractor" className="oc-modal">
          <a href="#!" className="global-close" data-track="conceal" data-track-accordion="find a contractor"></a>

          <div className="modal-body sm">
            <div className="close-container">
              <a href="#!" className="close" data-track="conceal" data-track-accordion="find a contractor">&times;</a>
            </div>

            <div className="modal-content">
              <h5 className="heading">{t('build_your_roof.summary_quote')}</h5>

              <p>{t('build_your_roof.summary_quote_directing')}</p>
              <p>{t('build_your_roof.summary_quote_request_cta')}</p>

              <CTAButton byrId={this.state.roofId} href={`/roofing/contractors${referral}`} target="_blank" data-track="find-a-professional" data-track-professional="contractor">{t('build_your_roof.summary_quote_letsdothis')}</CTAButton>

            </div>
          </div>
        </div>
      </Section>
    );
  }
}
export const Summary = withRouter(connectLocation(ContractorNameReduxConnector(ConfigurationConnector(XSummary))));
